<template>
  <div class="register-page">
    <v-row no-gutters>
      <!-- form -->
      <v-col cols="10" md="12" sm="12" class="mt-1 mx-auto">
        <v-col cols="12" md="12" sm="12">
          <v-img
            src="/img/fantasy_lineups_logo.png"
            width="360"
            class="mx-auto"
          />
        </v-col>

        <v-card
          class="ma-6 pa-3 mx-auto"
          shaped
          elevation="3"
          ripple
          raised
          color="#F5F5F5"
          max-width="500"
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="register"
          >
            <div align="center" class="mt-n5">
              <v-col cols="12" md="12" sm="12" align="center">
                <p class="text-h5 green--text font-weight-bold">
                  Forgot Password
                </p>
              </v-col>
            </div>

            <!-- //* old password -->
            <div align="center" class="mt-n5">
              <v-col cols="12" md="8" sm="12">
                <v-text-field
                  class="input"
                  v-model="form.password"
                  :rules="passwordRules"
                  label="Password*"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  outlined
                  filled
                  required
                  prepend-inner-icon="mdi-form-textbox-password"
                ></v-text-field
              ></v-col>
            </div>

            <!-- //* New password -->
            <div align="center" class="mt-n5">
              <v-col cols="12" md="8" sm="12">
                <v-text-field
                  class="input"
                  v-model="form.NewPassword"
                  :rules="passwordRules"
                  label="New Password*"
                  :type="showNewpassword ? 'text' : 'password'"
                  :append-icon="showNewpassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showNewpassword = !showNewpassword"
                  outlined
                  filled
                  required
                  prepend-inner-icon="mdi-form-textbox-password"
                ></v-text-field
              ></v-col>
            </div>

            <!-- //* confirm new password -->
            <div align="center" class="mt-n5">
              <v-col cols="12" md="8" sm="12">
                <v-text-field
                  class="input"
                  v-model="form.ConfirmPassword"
                  :rules="[passwordConfirmationRule]"
                  label="Confirm New Password*"
                  :type="showNewpassword ? 'text' : 'password'"
                  outlined
                  filled
                  required
                  prepend-inner-icon="mdi-form-textbox-password"
                ></v-text-field
              ></v-col>
            </div>

            <!-- //* button -->
            <div align="center" class="mt-n5">
              <v-col cols="12" md="8" sm="12" class="mt-n5">
                <v-btn block color="#00C853" type="submit" class="mr-4">
                  <v-progress-circular
                    v-if="getTeamLoader"
                    indeterminate
                    :width="5"
                    color="primary"
                  ></v-progress-circular>
                  Confirm
                </v-btn>
              </v-col>
            </div>

            <v-col cols="12" md="12" align="center">
              <small class="body-2">
                Already have account?
                <router-link to="/login" color="blue">Login</router-link>
              </small>
            </v-col>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "forgetPassword",
  title: "Fantasy Lineups Forgot password Page",

  data: () => ({
    valid: true,
    showPassword: false,
    showNewpassword: false,
    snackbar: false,
    text: "",

    passwordRules: [
      (v) =>
        (v && /^[a-z0-9\-]+$/.test(v)) ||
        `Only lowercase letters, numbers or hyphens allowed`,
      (v) => v.length >= 6 || "Min 6 characters",
    ],

    // select: null,
    // items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,

    form: {
      password: "",
      NewPassword: "",
      ConfirmPassword: "",
    },
  }),

  computed: {
    ...mapGetters("NbaModule", ["getTeamLoader"]),
    ...mapState("NbaModule", ["customerSession"]),

    passwordConfirmationRule() {
      return () =>
        this.form.NewPassword === this.form.ConfirmPassword ||
        "Password must match";
    },
  },

  methods: {
    register() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("NbaModule/resetPassword", {
            userId: localStorage.getItem("user"),
            currentPassword: this.form.password,
            newPassword: this.form.NewPassword,
            confirmPassword: this.form.ConfirmPassword,
          })
          .then(() => {
            if (this.$store.state.NbaModule.forgetPass.success) {
              localStorage.clear();
              this.$router.push("/login");
            } else {
              this.$router.push("/pricing");
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.register-page {
  background-color: #212121;
  min-height: 100vh;
}

.input >>> input {
  color: rgba(0, 0, 0, 0.87);
  margin-top: 0px;
}
</style>
